import { type ReactElement } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import { getFieldErrorMessages } from 'global/helpers/form'
import type { KNFormCheckboxProps } from './types'
import theme from 'assets/theme'

const KNFormCheckbox = <T extends FieldValues>({
  name,
  control,
  rules,
  label,
  size,
  sx,
  disabled,
  onCheck,
}: KNFormCheckboxProps<T>): ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, value }, fieldState: { invalid, error }, formState }): ReactElement => (
      <FormControl fullWidth sx={sx} error={invalid} disabled={formState.isSubmitting ?? disabled}>
        <FormControlLabel
          control={
            <Checkbox
              checked={value}
              onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
                onCheck?.()
                onChange(event.target.checked)
              }}
              size={size}
              sx={{
                py: 0,
                color: theme.palette.primary.main,
              }}
            />
          }
          label={label}
        />
        {error?.message && <FormHelperText>{getFieldErrorMessages(error)}</FormHelperText>}
      </FormControl>
    )}
  />
)

export default KNFormCheckbox
